import React from 'react';
import { NOTIFICATION_FILTERS } from '../../utils/notificationUtils';

const NotificationFilters = ({ activeCategory = 'all', counts = {}, onChange }) => (
  <div className="flex flex-wrap gap-2">
    {NOTIFICATION_FILTERS.map((filter) => {
      const active = activeCategory === filter.key;
      const count = counts[filter.key] || 0;
      return (
        <button
          key={filter.key}
          type="button"
          onClick={() => onChange?.(filter.key)}
          className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
            active
              ? 'bg-blue-600 text-white'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600'
          }`}
        >
          {filter.label}
          {count > 0 && <span className="ml-1 opacity-80">({count})</span>}
        </button>
      );
    })}
  </div>
);

export default NotificationFilters;
